// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"styles_skeleton__W8XZA","shimmer":"styles_shimmer__3hEgA","browser-ie":"styles_browser-ie__2SbEK"};